<!--
 * @Author: M.D.
 * @Date: 2019-12-11 16:47:38
 * @LastEditors: M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="bottom-footer">
    <!-- <el-row>
      <el-col :span="20" :offset="2">
        <div class="features">
          <ul class="list">
            <li class="item">
              <div class="wrapper">
                <span class="icon">
                  <img src="@/assets/image/footer_1.png" alt="" />
                </span>
                服务质量有保障
              </div>
            </li>
            <li class="item">
              <div class="wrapper">
                <span class="icon">
                  <img src="@/assets/image/footer_2.png" alt="" />
                </span>
                服务种类显丰富
              </div>
            </li>
            <li class="item">
              <div class="wrapper">
                <span class="icon">
                  <img src="@/assets/image/footer_3.png" alt="" />
                </span>
                服务品质有保证
              </div>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row> -->
    <div class="bottom_top">
      <div class="b_content">
        <div class="item_bo first_f">
          <div class="item_title">客户服务</div>
          <div class="khfu_img">
            <div>
              <div class="kefu_icon1" @click="myPoint">
                <img src="@/assets/image/jfdh.png" alt="" />
              </div>
              <div class="bottom_wenzi jehd">积分好兑</div>
            </div>
            <div>
              <div class="kefu_icon1" @click="question">
                <img src="@/assets/image/cjwt.png" alt="" />
              </div>
              <div class="bottom_wenzi jehd">常见问题</div>
            </div>
          </div>
        </div>
        <div class="item_bo">
          <div class="item_title">千街万巷公众号</div>
          <div class="content">
            <div class="kf-img-wrapper">
              <img src="@/assets/image/footer_qjwx.png" alt="" />
            </div>
            <div class="right_w bottom_wenzi i_h">
              <div>扫描二维码</div>
              <div>关注千街万巷公众号</div>
              <div>微信公众号</div>
            </div>
          </div>
        </div>
        <div class="item_bo">
          <div class="item_title">千街云服务</div>
          <div class="content">
            <div class="kf-img-wrapper">
              <img src="@/assets/image/esp_qr.jpeg" alt="" />
            </div>
            <div class="right_w bottom_wenzi i_h">
              <div>扫描二维码</div>
              <div>关注千街云服务</div>
              <div>微信公众号</div>
            </div>
          </div>
        </div>

        <div class="item_bo">
          <div class="item_title">成都千街万巷商务服务有限公司 官网</div>
          <div class="content">
            <div class="kf-img-wrapper" @click="officalWebsite">
              <img src="@/assets/image/footer_o.png" alt="" />
            </div>
            <div class="right_w bottom_wenzi i_h">
              <div>点击图片访问片</div>
              <div>成都千街万巷商务服务有限公司</div>
              <div>公司官方网站</div>
            </div>
          </div>
        </div>

        <div class="item_bo">
          <div class="item_title"></div>
          <div class="content">
            <div class="right_w bottom_wenzi i_h">
              <div>服务质量有保障</div>
              <div>服务种类显丰富</div>
              <div>服务品质有保证</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="byn_ba">
      <span  class="copyright">版权所有© 成都千街万巷商务服务有限公司 V2.0</span>
      <a class="copyright" href="https://beian.miit.gov.cn/">
        <span style="margin-left: 10px">ICP备案号：蜀ICP备20017293号</span>
      </a>
    </div>
  </div>
</template>

<script>
import { usrStatus } from '@/util/mixin'
export default {
  mixins: [usrStatus],
  props: {},
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  methods: {
    officalWebsite() {
      window.open(`https://www.chinaqjwx.cn/`, '_blank')
    },
    question() {
      this.$router.push({
        name: 'qa',
      })
    },
    myPoint() {
      if (!this.isLogin) {
        this.$emit('openLoginDialog')
        return
      }
      this.$router.push({
        name: 'mypoint',
      })
    },
  },
  components: {},
}
</script>

<style lang="stylus" scoped>
.byn_ba{
  display: flex;
}
.bottom-footer {
  height: 330px;
  background-color: #4c453f;
  color: #ffffff;

  .bottom_top {
    height: 230px;
    width: 100%;

    .b_content {
      width: 1400px;
      height: 230px;
      margin: auto;
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .first_f {
        width: 173px;
      }

      .item_bo {
        height: 150px;

        .content {
          display: flex;
          margin-top: 30px;

          .kf-img-wrapper {
            width: 100px;
            height: 100px;

            img {
              width: 100px;
              height: 100px;
            }
          }

          .right_w {
            margin-left: 20px;
            padding: 10px 0;
          }

          .i_h {
            div {
              height: 30px;
              lint-height: 30px;
            }
          }
        }

        .item_title {
          height: 21px;
          text-align: center;
          font-family: AdobeHeitiStd-Regular;
          font-size: 20px;
          font-weight: bold;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 0px;
          color: #fffefe;
        }

        .khfu_img {
          display: flex;
          justify-content: space-between;
          margin-top: 30px;

          .kefu_icon1 {
            width: 60px;
            height: 60px;
          }

          .jehd {
            margin-top: 10px;
          }
        }
      }
    }
  }

  .features {
    .list {
      display: flex;
    }

    .item {
      height: 118px;
      flex: 1 1 auto;
      display: inline-block;
      center();
      border-bottom: 1px solid #707070;

      .wrapper {
        center();

        .icon {
          height: 55px;
          width: 55px;
          display: inline-block;
          border-radius: 50%;
          border: 1px solid #ffffff;
          margin-right: 10px;
          center();

          img {
            width: 30px;
            height: 30px;
            display: inline-block;
          }
        }
      }
    }
  }

  .copyright {
    center();
    height: 19px;
    font-size: 18px;
    color: #fffefe;
    margin-top: 30px;
  }
}

.bottom_wenzi {
  font-family: AdobeHeitiStd-Regular;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #fffefe;
}
</style>
